module.exports = __webpack_public_path__ + "media/proximanova-regular.851cc7d6.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/proximanova-regular.woff2
// module id = 106
// module chunks = 9